import { CheckCircleFilled, ErrorCircleFilled } from '@ori-ui/icons';
import { styled, Typography } from '@ori-ui/mui';
import type { FC } from 'react';

import { Localization } from '../../../Localization';
import { defaultTranslations } from '../../../constants/defaultTranslations_simplified-registration-BrandPartner';
import { TranslationKey } from '../../../models';
import type { IPasswordRequirement } from './PasswordFieldByConfig';

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));

const CheckIcon = styled(CheckCircleFilled)(({ theme }) => ({
  color: theme.palette.default.light,
  marginRight: theme.spacing(1),
}));

const CheckIconSuccess = styled(CheckCircleFilled)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: theme.spacing(1),
}));

const ErrorIcon = styled(ErrorCircleFilled)(({ theme }) => ({
  color: theme.palette.error.dark,
  marginRight: theme.spacing(1),
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.default.main,
}));

interface IPasswordRequirementsProps {
  requirements?: IPasswordRequirement[];
  minChar?: number;
  actualValue?: string;
  validating: boolean;
}

const getValidationIcon = (requirementProperty: IPasswordRequirement, value?: string) =>
  requirementProperty.validationRegex.test(value ?? '') ? <CheckIconSuccess /> : <ErrorIcon />;

export const PasswordRequirements: FC<IPasswordRequirementsProps> = (props) => {
  const { requirements, minChar, actualValue, validating } = props;

  return (
    <div>
      {requirements?.map((requirement) => (
        <IconWrapper key={requirement.key}>
          {validating ? getValidationIcon(requirement, actualValue) : <CheckIcon />}
          <StyledLabel variant="caption">
            <Localization
              defaultMessage={defaultTranslations[requirement.key]}
              id={requirement.key as TranslationKey}
              values={{ min: minChar }}
            />
          </StyledLabel>
        </IconWrapper>
      ))}
    </div>
  );
};
